/**
 * Created by danielg on 8/16/15.
 */
define(function (require) {

    var WebAgentLogger = require('web-agent-assets-js/WebAgentLogger');

    /////////// CLASS DEFINITION /////////////
    var lpModelController = function (model) {
        /////////// INITIALIZATION /////////////
        var _model = model;
        this.applicationType = 'lpModelController';
        this.logger = WebAgentLogger.getLogger(this.applicationType);

        /////////// PUBLIC FUNCTIONS /////////////

        /**
         * Gets a parameter from the model
         * @param key - The key for the model
         * @returns {*}
         */
        this.getModelParam = function (key) {
            if (_model) {
                return _model.get(key);
            } else if (this.logger) {
                this.logger.warn('No model!', 'getModelParam');
            }
        };

        /**
         * Binds to a parameter in the model
         * @param key - The key for the model
         * @param callback - The callback function which will be triggered when there's a change in the parameter's value
         * @param context - The context for the callback function
         * @param trigger - If true, the callback will be triggered for existing data. If false - it won't.
         */
        this.bindModelParam = function(key, callback, context, trigger) {
            if (_model) {
                _model.bind(key, callback, context, trigger);
            } else if (this.logger) {
                this.logger.warn('No model!', 'bindModelParam');
            }
        };

        /**
         * Unbinds from a parameter in the model
         * @param key - The key for the model
         * @param callback - The callback function which was used to bind
         * @param context - The context which was used to bind
         */
        this.unbindModelParam = function(key, callback, context) {
            if (_model) {
                _model.unbind(key, callback, context);
            } else if (this.logger) {
                this.logger.warn('No model!', 'unbindModelParam');
            }
        };
    };

    return lpModelController;

});
